export default "__VITE_ASSET__DHRY8pwn__"